import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_DDPARTS';

const en = {
    expand: 'Expand',
    help: 'help',
    settingToolTip: 'Here you can edit and choose your preferred fields',
    selected: 'Selected X',
    clear: 'Clear All',
    cancel: 'Cancel',
    confirm: 'Add',
    searchPlaceholder: 'Search...',
    dialogTitle: 'Choose Parts',
    inventoryDetails: 'Inventory Details',
    view: 'View',
    showing: 'Loading',
    emptyState: 'We did not find any results for your search.',
    partsEmptyState:
        'We did not find the parts you are looking for. \n Try broadening your search, or filter by Part Family.',
    familyLabel: 'Part Family',
    allFamilies: 'All Families',
    selectFamily: 'Choose Families',
    add: 'Add',
    search: 'Search',
    addQuantityField: 'Add Quantity field',
    quantityHelp: 'help'
};

const he = {
    expand: 'הרחבה',
    help: 'עזרה',
    settingToolTip: 'כאן אפשר לבחור את השדות להצגה ולערוך את סדר הופעתם.',
    selected: 'נבחרו X',
    clear: 'נקה הכל',
    cancel: 'ביטול',
    confirm: 'הוספה',
    searchPlaceholder: 'חיפוש...',
    dialogTitle: 'בחירת מוצרים',
    inventoryDetails: ' פרטי מלאי',
    view: 'צפייה',
    showing: 'טוען',
    emptyState: 'לא מצאנו תוצאות לחיפוש שלך.',
    partsEmptyState: 'לא מצאנו תוצאות. \n נסו להרחיב את טווח החיפוש, או לחפש לפי משפחת מוצר. ',
    familyLabel: 'משפחת מוצר',
    allFamilies: 'כל המשפחות',
    selectFamily: 'בחירת משפחה',
    add: 'אישור',
    search: 'חיפוש',
    addQuantityField: 'הוספת שדה כמות',
    quantityHelp: 'עזרה'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'expand',
    2: 'help',
    3: 'settingToolTip',
    4: 'selected',
    5: 'clear',
    6: 'cancel',
    7: 'confirm',
    10: 'searchPlaceholder',
    19: 'quantityHelp',
    22: 'dialogTitle',
    23: 'inventoryDetails',
    24: 'view',
    25: 'showing',
    26: 'emptyState',
    27: 'familyLabel',
    28: 'allFamilies',
    29: 'selectFamily',
    30: 'add',
    31: 'search',
    33: 'partsEmptyState'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
